export default __webpack_public_path__ + "static/media/water-full.5f7c55b1.png";